.root {
  flex: 1; /* fill height if inside flex container in consumer app */
  display: flex;
  min-width: 0;
  min-height: 0;
  margin: 0;
}

.canvas {
  margin-right: 1rem;
}
